import {Grid} from '@material-ui/core'
import _t, {_} from 'i18n'
import React, {useCallback} from 'react'

import {ContainerHeader, DetailContainer, Paper} from '../styles'

const CountyInfo = ({demographic_data}) => {
  const formatCurrency = (amount, multiply) =>
    new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      notation: 'compact',
    }).format(multiply ? multiply * amount : amount)

  const formatNumber = (amount) => new Intl.NumberFormat('pt-BR').format(amount)

  const findDemographicInfo = useCallback(
    (key, defaultParam = _`Não Informado`, label = '') => {
      const info = demographic_data?.find(({indicator}) => indicator === key)?.value
      return info ? `${info}${label}` : `${defaultParam}${label}`
    },
    [demographic_data],
  )

  return (
    <Paper>
      <ContainerHeader>{_`Informações Sobre o Município`}</ContainerHeader>
      <DetailContainer>
        <Grid container>
          <Grid item lg={6} style={{display: 'flex', justifyContent: 'flex-start'}}>
            <table className="table demodata" style={{marginRight: '40px'}}>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`População estimada`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('populacao_estimada', 0))} {_`habitantes`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`IDEB`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('taxa_escolarizacao', 0))} </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`IDHM`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('idhm', 0))} </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Salário Médio Mensal`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('salario_medio_mensal', 0))} {_`salários mínimos`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Rendimento nominal`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('percentual_rendimento_nominal', 0))}%{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Total de despesas`} </b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatCurrency(findDemographicInfo('total_despesas', 0), 1000)} </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Total de receitas`} </b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatCurrency(findDemographicInfo('total_receitas', 0), 1000)} </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Percentual de receita externa`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('percentual_receita_externa', 0))}%{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`PIB per capita`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatCurrency(findDemographicInfo('pib_per_capta', 0))} </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Pessoal Ocupado`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('pessoal_ocupado', 0))} {_`pessoas`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`População Ocupada`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('populacao_ocupada', 0))}% </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Arborização`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('arborizacao', 0))}% </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Urbanização`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('urbanizacao', 0))}% </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Densidade Demográfica`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('densidade_demografica', 0))} {_`hab/km²`}
                </td>
              </tr>
            </table>
          </Grid>
          <Grid item lg={6} style={{display: 'flex', justifyContent: 'flex-start'}}>
            <table className="table demodata" style={{marginLeft: '40px'}}>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Taxa de Escolarização`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('taxa_escolarizacao', 0))}% </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Anos iniciais (Ensino Fundamental)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('anos_iniciais_ensino_fundamental', 0))} {_`anos`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Matrículas (Ensino Fundamental)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('matriculas_ensino_fundamental', 0))} {_`matrículas`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Matrículas (Ensino Médio)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('matriculas_ensinoMedio', 0))} {_`matrículas`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Docentes (Ensino Fundamental)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('docentes_ensino_fundamental', 0))} {_`docentes`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Docentes (Ensino Médio)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('docentes_ensino_medio', 0))} {_`docentes`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Escolas (Ensino Fundamental)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('escolas_ensino_fundamental', 0))} {_`escolas`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Escolas (Ensino Médio)`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('escolas_ensino_medio', 0))} {_`escolas`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Mortalidade Infantil`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('mortalidade_infantil', 0))} {_`óbitos por mil nascidos vivos`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Internação por diarreia`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('internacao_diarreia', 0))} {_`internações por mil habitantes`}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Estabelecimentos SUS`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('estabelecimentos_sus', 0))} {_`estabelecimentos`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Unidade Territorial`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>
                  {formatNumber(findDemographicInfo('unidade_territorial', 0))} {_`km²`}{' '}
                </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Esgotamento Sanitário Adequado`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{formatNumber(findDemographicInfo('esgotamento_sanitario', 0))}% </td>
              </tr>
              <tr>
                <td>
                  <label>
                    <b style={{fontSize: 14}}>{_`Bioma`}</b>
                  </label>
                </td>{' '}
                <td style={{textAlign: 'right'}}>{findDemographicInfo('bioma', 0)}</td>
              </tr>
            </table>
          </Grid>
        </Grid>
      </DetailContainer>
    </Paper>
  )
}

export default CountyInfo
